export default __webpack_public_path__ + "static/media/assets_liabilities_02.d86bb181.png";